export const getPreference = (userId, prefType) => {
  const preferences = JSON.parse(localStorage.getItem(`preferences_${userId}`) ?? '{}');
  return preferences[prefType];
};

export const storePreference = (userId, prefType, value) => {
  const preferences = JSON.parse(localStorage.getItem(`preferences_${userId}`) ?? '{}');
  preferences[prefType] = value;
  localStorage.setItem(`preferences_${userId}`, JSON.stringify(preferences));
};
